import React, { useState, useEffect } from "react";
import classnames from "classnames/bind";
import { connect } from "react-redux";
import { getFacility } from "src/utils/Firebase";
import { getFacilitySuccess, setFacilityId } from "src/redux/facility/actions";

import css from "./index.scss";
import NewFacility from "./components/NewFacility";

const cx = classnames.bind(css);
const moduleName = "Facilities";

const Facilities = ({ facility, getFacilitySuccess, setFacilityId }) => {
  const [showFacilityModal, setShowFacilityModal] = useState(false);
  const password = window.localStorage.getItem("passwordForSignIn");

  useEffect(() => {
    getFacility()
      .limitToLast(30)
      .once("value")
      .then((res) => getFacilitySuccess(res.val()));
  }, []);

  const selected = facility.data.find((v) => v.id === facility.id);

  return (
    <div className={cx(moduleName)}>
      <NewFacility
        showFacilityModal={showFacilityModal}
        handleClose={() => setShowFacilityModal(false)}
      />

      <div className={cx(`${moduleName}-header`)}>
        <div className={cx(`${moduleName}-header-wrapper`)} />
        <div className={cx(`${moduleName}-header-content`)}>
          <p className={cx(`${moduleName}-header-label`)}>Amenities</p>
          <h2>부대시설</h2>
          <h4>족구장, 축구장, 가마솥 체험 등 다양한 시설을 즐기세요</h4>
        </div>
      </div>

      {facility.data.length > 0 && (
        <React.Fragment>
          {/* Tab navigation */}
          <div className={cx(`${moduleName}-tabs`)}>
            <div className={cx(`${moduleName}-tabs-inner`)}>
              {facility.data.map((item) => (
                <button
                  key={item.id}
                  className={cx(`${moduleName}-tab`, { active: item.id === facility.id })}
                  onClick={() => setFacilityId({ id: item.id })}
                >
                  {item.title}
                </button>
              ))}
            </div>
            {password && (
              <button
                className={cx(`${moduleName}-add-btn`)}
                onClick={() => setShowFacilityModal(true)}
              >
                + 추가
              </button>
            )}
          </div>

          {/* Selected facility content */}
          {selected && (
            <div className={cx(`${moduleName}-content`)} key={selected.id} data-aos="fade-up">
              <div className={cx(`${moduleName}-content-img`)}>
                <img src={selected.imageurl} alt={selected.title} />
              </div>
              <div className={cx(`${moduleName}-content-info`)}>
                <p className={cx(`${moduleName}-content-label`)}>Facility</p>
                <h2 className={cx(`${moduleName}-content-title`)}>{selected.title}</h2>
                <div className={cx(`${moduleName}-content-divider`)} />
                <p className={cx(`${moduleName}-content-desc`)}>{selected.content}</p>
              </div>
            </div>
          )}
        </React.Fragment>
      )}
    </div>
  );
};

export default connect(
  ({ facility }) => ({ facility }),
  { getFacilitySuccess, setFacilityId }
)(Facilities);



// WEBPACK FOOTER //
// ./src/App/pages/Home/pages/Facility/index.js